import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import AppParagraphTitle from '../typography/ParagraphTitle';

const useStyles = makeStyles(() => ({
  content: {
    padding: '0 !important',
    height: '100%',
  },
  title: {
    marginRight: 'auto',
    marginLeft: 15,
  },
  actions: {
    boxShadow: "0px 2px 4px rgba(0,0,0,0.14), 0px -2px 4px rgba(0,0,0,0.14)",
  },
}));

export type AppFullScreenMediaProps = {
  children: React.ReactNode,
  title?: string | null,
  onClose: () => void,
};

function AppFullScreenMedia({ children, title, onClose }: AppFullScreenMediaProps) {
  const classes = useStyles();

  return (
    <Dialog
      fullScreen
      open={true}
      onClose={onClose}
    >
      <DialogContent className={classes.content}>
        {children}
      </DialogContent>
      <DialogActions className={classes.actions}>
        {title &&
          <AppParagraphTitle className={classes.title} text={title} />
        }
        <Button
          autoFocus
          onClick={onClose}
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AppFullScreenMedia;
